import { Overlay } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import * as i0 from '@angular/core';
import { inject, Injectable } from '@angular/core';

/**
 * Provide the Overlay Service within your component instance, not the Module nor Root.
 */
class OverlayService {
    #portal;
    #viewContainerRef;
    #overlayRef;
    #overlay = inject(Overlay);
    /** Sequence 1: Register view container Ref injected in consumer */
    init(viewContainerRef) {
        this.#viewContainerRef = viewContainerRef;
        return this;
    }
    /** Sequence 2: Creates an instance of the CDK overlay */
    createOverlay(opts) {
        if (!this.#viewContainerRef) {
            throw new Error('ViewContainerRef is not initialized');
        }
        const positionStrategy = this.#overlay.position().global().centerHorizontally().centerVertically();
        const scrollStrategy = this.#overlay.scrollStrategies.block();
        const config = {
            hasBackdrop: true,
            disposeOnNavigation: true,
            scrollStrategy,
            positionStrategy,
            ...opts,
        };
        this.#overlayRef = this.#overlay.create(config);
        return this;
    }
    /** Sequence 3: Creates a template portal for the Modal */
    createTemplatePortal(template) {
        if (!this.#viewContainerRef) {
            throw new Error('ViewContainerRef is not initialized');
        }
        this.#portal = new TemplatePortal(template, this.#viewContainerRef);
        return this;
    }
    /** Sequence 4: Renders the portal to the overlay */
    attachPortal() {
        if (!this.#overlayRef) {
            throw new Error('OverlayRef is not initialized');
        }
        if (!this.#portal) {
            throw new Error('The Portal is not initialized');
        }
        this.#overlayRef.attach(this.#portal);
        return this;
    }
    /** When the modal is clicked */
    overlayBackdropClick() {
        if (!this.#overlayRef) {
            throw new Error('OverlayRef is not initialized');
        }
        return this.#overlayRef.backdropClick();
    }
    /** Destroys the portal and overlay */
    destroyOverlay() {
        this.#overlayRef?.detach();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: OverlayService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: OverlayService, providedIn: null }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: OverlayService, decorators: [{
            type: Injectable,
            args: [{ providedIn: null }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { OverlayService };
